// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Customer_modal__mLKvK {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.Customer_upper__Tgqa7 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media only screen and (max-width: 43.75em) {
  .Customer_upper__Tgqa7 {
    display: grid;
    grid-template-columns: min-content max-content;
    gap: 1rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .Customer_upper__Tgqa7 {
    grid-template-columns: min-content max-content;
    gap: 1rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .Customer_upper__Tgqa7 > :nth-child(2) {
    grid-row: 1/2;
    grid-column: 1/3;
    justify-self: center;
  }
}
@media only screen and (max-width: 43.75em) {
  .Customer_upper__Tgqa7 > :last-child {
    grid-column: 2/3;
    justify-self: end;
  }
}
@media only screen and (max-width: 43.75em) {
  .Customer_upper__btns__fvsTk {
    display: flex;
    gap: 2rem;
  }
}
@media only screen and (max-width: 31.25em) {
  .Customer_upper__btns__fvsTk {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
}

.Customer_customer__num__XZH7O {
  width: 18rem;
  background-color: var(--color-white);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 6rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
}
.Customer_customer__search__zY7wi {
  position: relative;
  top: -1.3rem;
}
@media only screen and (max-width: 56.25em) {
  .Customer_customer__search__zY7wi {
    top: -0.5rem;
  }
}
.Customer_customer__list__eyxOr {
  margin-top: 2rem;
  display: flex;
  position: relative;
}
.Customer_customer__avatar__okqoq {
  width: 9rem;
}
.Customer_customer__avatar_container__OFK52 {
  width: 10rem;
  height: 10rem;
  border-radius: 7rem;
  border: 1px solid var(--color-primary);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3rem 0;
}

.Customer_table__uftGz {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
}
.Customer_table__uftGz tr {
  display: grid;
  grid-template-columns: 25% 15% 28% 15% 17%;
  padding: 0 1rem;
  align-items: center;
}
@media only screen and (max-width: 37.5em) {
  .Customer_table__uftGz tr {
    grid-template-columns: 1fr;
  }
}
.Customer_table__uftGz th,
.Customer_table__uftGz td {
  padding: 2.2rem 2rem;
}
.Customer_table__uftGz th {
  font-weight: 700;
}
.Customer_table__uftGz td {
  cursor: pointer;
}
.Customer_table__uftGz tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Customer_table__uftGz tbody tr {
  background-color: var(--color-primary-3);
  border-radius: 1.3rem;
}
.Customer_table__uftGz tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
  border-radius: 1.3rem;
}

.Customer_minMenu__QpYGw {
  color: var(--color-primary);
  cursor: pointer;
  font-size: 2rem;
}

.Customer_gender__Rk68a {
  display: flex;
  justify-content: space-between;
}

.Customer_customerMenu__6Cd6F {
  background-color: var(--color-white);
  font-size: var(--default-font-small);
  position: absolute;
  right: 7rem;
  top: 8rem;
  border-radius: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--color-grey);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  color: var(--color-primary);
  box-sizing: border-box;
  width: 15rem;
}
.Customer_customerMenu__6Cd6F ul {
  margin: 1.2rem 1.7rem;
}
.Customer_customerMenu__6Cd6F ul > :not(:last-child) {
  margin-bottom: 1rem;
}
.Customer_customerMenu__6Cd6F li {
  list-style: none;
  cursor: pointer;
}
.Customer_customerMenu__6Cd6F li:hover {
  color: var(--color-primary-4);
  font-weight: 700;
}

.Customer_view__BsipL {
  position: relative;
}
.Customer_view_menu__7Er\\+1 {
  color: var(--color-primary);
  cursor: pointer;
  font-size: 3rem;
  position: absolute;
  left: 20.5rem;
  top: 6rem;
}
.Customer_view_customerMenu__6leFE {
  right: -20rem;
  top: 6rem;
}
.Customer_view_content__8GZBW {
  width: 38rem;
  margin-top: 3rem;
}

.Customer_midBtn__mYKvo {
  display: flex;
  justify-content: center;
}

.Customer_checks__oeJnp {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
}
.Customer_checks_group__SNWjE {
  align-self: center;
}

.Customer_error__JGdO1 {
  font-size: var(--default-font-small);
  color: var(--color-error);
  padding-left: 2rem;
  font-weight: 400;
  margin: 1rem 0;
}

.Customer_checks__oeJnp {
  width: 38rem;
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.Customer_measurement__wUwKN {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1rem;
  align-items: center;
  margin: 2rem 0;
  width: 38rem;
}
.Customer_measurement_delete__HtyvH {
  align-self: flex-end;
  font-size: 4.6rem;
}

.Customer_dropZone__dsaNx {
  display: flex;
  width: 38rem;
  justify-content: center;
  align-items: center;
  background-size: contain;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Customer/Customer.module.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAAF;AACE;EAJF;IAKI,aAAA;IACA,8CAAA;IACA,SAAA;EAEF;AACF;AAAE;EAVF;IAWI,8CAAA;IACA,SAAA;EAGF;AACF;AAAI;EADF;IAEI,aAAA;IACA,gBAAA;IACA,oBAAA;EAGJ;AACF;AACI;EADF;IAEI,gBAAA;IACA,iBAAA;EAEJ;AACF;AAEI;EADF;IAEI,aAAA;IACA,SAAA;EACJ;AACF;AAAI;EALF;IAMI,aAAA;IACA,sBAAA;IACA,MAAA;EAGJ;AACF;;AAEE;EACE,YAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,4CAAA;AACJ;AAEE;EACE,kBAAA;EACA,YAAA;AAAJ;AACI;EAHF;IAII,YAAA;EAEJ;AACF;AACE;EACE,gBAAA;EACA,aAAA;EACA,kBAAA;AACJ;AAEE;EACE,WAAA;AAAJ;AAEI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAAN;;AAOA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;AAJF;AAME;EACE,aAAA;EACA,0CAAA;EACA,eAAA;EACA,mBAAA;AAJJ;AAMI;EANF;IAOI,0BAAA;EAHJ;AACF;AAME;;EAEE,oBAAA;AAJJ;AAOE;EACE,gBAAA;AALJ;AAQE;EACE,eAAA;AANJ;AAUI;EACE,qBAAA;AARN;AAWI;EACE,wCAAA;EACA,qBAAA;AATN;AAWM;EACE,wCAAA;EACA,qBAAA;AATR;;AAeA;EACE,2BAAA;EACA,eAAA;EACA,eAAA;AAZF;;AAgBA;EACE,aAAA;EACA,8BAAA;AAbF;;AAgBA;EACE,oCAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mCAAA;EACA,4CAAA;EACA,2BAAA;EACA,sBAAA;EACA,YAAA;AAbF;AAeE;EACE,qBAAA;AAbJ;AAeI;EACE,mBAAA;AAbN;AAiBE;EACE,gBAAA;EACA,eAAA;AAfJ;AAiBI;EACE,6BAAA;EACA,gBAAA;AAfN;;AAqBA;EACE,kBAAA;AAlBF;AAmBE;EACE,2BAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,SAAA;AAlBJ;AAqBE;EACE,YAAA;EACA,gBAAA;AAnBJ;;AAwBA;EACE,aAAA;EACA,uBAAA;AArBF;;AAyBA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AAtBF;AAwBE;EACE,kBAAA;AAtBJ;;AA0BA;EACE,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAvBF;;AA0BA;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AAvBF;AAwBE;EACE,oBAAA;EACA,iBAAA;AAtBJ;;AA0BA;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;AAvBF","sourcesContent":["@import \"../variables/breakpoints\";\n.modal {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.upper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  @media only screen and (max-width: $bp-700) {\n    display: grid;\n    grid-template-columns: min-content max-content;\n    gap: 1rem;\n  }\n\n  @media only screen and (max-width: $bp-500) {\n    grid-template-columns: min-content max-content;\n    gap: 1rem;\n  }\n\n  & > :nth-child(2) {\n    @media only screen and (max-width: $bp-500) {\n      grid-row: 1/2;\n      grid-column: 1/3;\n      justify-self: center;\n    }\n  }\n\n  & > :last-child {\n    @media only screen and (max-width: $bp-700) {\n      grid-column: 2/3;\n      justify-self: end;\n    }\n  }\n\n  &__btns {\n    @media only screen and (max-width: $bp-700) {\n      display: flex;\n      gap: 2rem;\n    }\n    @media only screen and (max-width: $bp-500) {\n      display: flex;\n      flex-direction: column;\n      gap: 0;\n    }\n  }\n}\n\n.customer {\n  &__num {\n    width: 18rem;\n    background-color: var(--color-white);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 6rem;\n    border-radius: 1rem;\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n  }\n\n  &__search {\n    position: relative;\n    top: -1.3rem;\n    @media only screen and (max-width: $bp-900) {\n      top: -0.5rem;\n    }\n  }\n\n  &__list {\n    margin-top: 2rem;\n    display: flex;\n    position: relative;\n  }\n\n  &__avatar {\n    width: 9rem;\n\n    &_container {\n      width: 10rem;\n      height: 10rem;\n      border-radius: 7rem;\n      border: 1px solid var(--color-primary);\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin: 3rem 0;\n    }\n  }\n}\n\n//Table styles start\n\n.table {\n  width: 100%;\n  max-width: 100%;\n  border: none;\n  border-collapse: collapse;\n  box-sizing: border-box;\n  text-align: left;\n  font-size: var(--default-font-small);\n\n  tr {\n    display: grid;\n    grid-template-columns: 25% 15% 28% 15% 17%;\n    padding: 0 1rem;\n    align-items: center;\n\n    @media only screen and (max-width: $bp-600) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  th,\n  td {\n    padding: 2.2rem 2rem;\n  }\n\n  th {\n    font-weight: 700;\n  }\n\n  td {\n    cursor: pointer;\n  }\n\n  tbody {\n    & > :not(:last-child) {\n      margin-bottom: 1.5rem;\n    }\n\n    tr {\n      background-color: var(--color-primary-3);\n      border-radius: 1.3rem;\n\n      &:nth-child(even) {\n        background-color: var(--color-primary-7);\n        border-radius: 1.3rem;\n      }\n    }\n  }\n}\n\n.minMenu {\n  color: var(--color-primary);\n  cursor: pointer;\n  font-size: 2rem;\n}\n//Table styles end\n\n.gender {\n  display: flex;\n  justify-content: space-between;\n}\n\n.customerMenu {\n  background-color: var(--color-white);\n  font-size: var(--default-font-small);\n  position: absolute;\n  right: 7rem;\n  top: 8rem;\n  border-radius: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid var(--color-grey);\n  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n  color: var(--color-primary);\n  box-sizing: border-box;\n  width: 15rem;\n\n  ul {\n    margin: 1.2rem 1.7rem;\n\n    & > :not(:last-child) {\n      margin-bottom: 1rem;\n    }\n  }\n\n  li {\n    list-style: none;\n    cursor: pointer;\n\n    &:hover {\n      color: var(--color-primary-4);\n      font-weight: 700;\n    }\n  }\n}\n\n// View Container\n.view {\n  position: relative;\n  &_menu {\n    color: var(--color-primary);\n    cursor: pointer;\n    font-size: 3rem;\n    position: absolute;\n    left: 20.5rem;\n    top: 6rem;\n  }\n\n  &_customerMenu {\n    right: -20rem;\n    top: 6rem;\n  }\n\n  &_content {\n    width: 38rem;\n    margin-top: 3rem;\n  }\n}\n\n//Add Customers\n.midBtn {\n  display: flex;\n  justify-content: center;\n}\n\n//checkbox\n.checks {\n  display: flex;\n  justify-content: space-between;\n  margin: 1rem 0 2rem 0;\n\n  &_group {\n    align-self: center;\n  }\n}\n\n.error {\n  font-size: var(--default-font-small);\n  color: var(--color-error);\n  padding-left: 2rem;\n  font-weight: 400;\n  margin: 1rem 0;\n}\n\n.checks {\n  width: 38rem;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 2rem;\n}\n\n.measurement {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 1rem;\n  align-items: center;\n  margin: 2rem 0;\n  width: 38rem;\n  &_delete {\n    align-self: flex-end;\n    font-size: 4.6rem;\n  }\n}\n\n.dropZone {\n  display: flex;\n  width: 38rem;\n  justify-content: center;\n  align-items: center;\n  background-size: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `Customer_modal__mLKvK`,
	"upper": `Customer_upper__Tgqa7`,
	"upper__btns": `Customer_upper__btns__fvsTk`,
	"customer__num": `Customer_customer__num__XZH7O`,
	"customer__search": `Customer_customer__search__zY7wi`,
	"customer__list": `Customer_customer__list__eyxOr`,
	"customer__avatar": `Customer_customer__avatar__okqoq`,
	"customer__avatar_container": `Customer_customer__avatar_container__OFK52`,
	"table": `Customer_table__uftGz`,
	"minMenu": `Customer_minMenu__QpYGw`,
	"gender": `Customer_gender__Rk68a`,
	"customerMenu": `Customer_customerMenu__6Cd6F`,
	"view": `Customer_view__BsipL`,
	"view_menu": `Customer_view_menu__7Er+1`,
	"view_customerMenu": `Customer_view_customerMenu__6leFE`,
	"view_content": `Customer_view_content__8GZBW`,
	"midBtn": `Customer_midBtn__mYKvo`,
	"checks": `Customer_checks__oeJnp`,
	"checks_group": `Customer_checks_group__SNWjE`,
	"error": `Customer_error__JGdO1`,
	"measurement": `Customer_measurement__wUwKN`,
	"measurement_delete": `Customer_measurement_delete__HtyvH`,
	"dropZone": `Customer_dropZone__dsaNx`
};
export default ___CSS_LOADER_EXPORT___;
